/* eslint-disable no-unused-vars */
import { deepClone } from '@/helpers/utils';
import ar from '@/local/ar';
import router from '@/routes';
import globalStore from '@/store/index';
import { caseClassificationEnum, casePartyRoleEnum, partyTypeEnum, socialIdentityTypeEnum, userType } from '../../../helpers/enum';
// import { requestStatus } from '@/helpers/enum';
import {
  calculateAge,
  getCasePartyId,
  getCasePartyName,
  isCasePartyExists,
  isCasePartyExistsExceptSelected,
  isCasePartyNotNeedRepresentative,
  isDead,
  isDefendant,
  isDefendantRepresentative,
  isDefendantRepresentativeRepresentative,
  isInheritor,
  isLawyer,
  isNoOneExists,
  isOrganization,
  isOrganizationOwner,
  isPerson,
  isPersonNotInheritor,
  isPersonOrOrganizationOwner,
  isProsecutor,
  isProsecutorOrProsecutorRepresentative,
  isProsecutorRepresentative,
  isProsecutorRepresentativeRepresentative,
  isRepresentative,
  isSameCaseParties,
  oneOrMoreExists,
  refineCasePartiesAfterAPI,
  requiredDefendantInCaseCategory,
} from '../helpers/utils';
const namespace = 'LawsuitModule';
const lookupsNamespace = 'LookupsModule';
const globalModuleNamespace = 'GlobalModule';

const store = (customNameSpace) => {
  return {
    state: globalStore.state[customNameSpace || namespace],
    getters: Object.keys(globalStore.getters)
      .reduce((obj, key) => {
        if (key.includes(customNameSpace || namespace + '/')) { obj[key.replace(customNameSpace || namespace + '/', '')] = globalStore.getters[key]; }
        return obj;
      }, {}),
    dispatch: (actionName, payload) =>
      globalStore.dispatch(`${customNameSpace || namespace}/${actionName}`, payload),
  };
};

export default {
  refineLawsuitCase: data =>
    new Promise((resolve) => {
      const caseData = deepClone(data);
      if ((caseData.laborCaseRequests || []).length) {
        const lookupsNamespace = 'LookupsModule';
        caseData.laborCaseRequests.forEach((obj) => {
          store(lookupsNamespace)
            .dispatch('getLaborRequests')
            .then((laborRequests) => {
              obj.isSingle = laborRequests.some(
                lr =>
                  lr.isSingle &&
                  (lr.id === obj.laborRequestType || lr.id === obj.mainLaborRequestType)
              );
            });
        });
      }
      resolve(caseData);
    }),
  refineLawsuitCaseParties: data =>
    new Promise((resolve) => {
      const caseParties = deepClone(data);
      resolve(refineCasePartiesAfterAPI(caseParties));
    }),
  validateLawsuitCaseCategory: () =>
    new Promise((resolve) => {
      resolve();
    }),
  validateLawsuitCaseSubject: caseData =>
    new Promise((resolve) => {
      resolve();
    }),
  validateLawsuit: bypassValidation =>
    new Promise((resolve, reject) => {
      if (bypassValidation) resolve();
      const selectedCaseType = store().getters.selectedCaseType;
      if (typeof (selectedCaseType || {}).mustHaveNoDefendant === 'undefined') {
        router.push({ path: `/lawsuit-requests/${store().getters.requestObjectKey}` });
        return reject(ar.lawsuitValidations.errorWhileLoadingData);
      }
      const prosecutors = store().getters.prosecutors;
      const defendants = store().getters.defendants;
      const prosecutorIds = store().getters.prosecutorIds;
      const prosecutorsWithoutInheritorsLength = Object.values(prosecutors).filter(x => !isInheritor(x)).length;
      const defendantsWithoutInheritorsLength = Object.values(defendants).filter(x => !isInheritor(x)).length;
      const prosecutorRepresentativeIds = store().getters.prosecutorRepresentativeIds;
      const prosecutorAndRepresentativeIds = prosecutorIds.concat(prosecutorRepresentativeIds);
      const companyManagerIds = store().getters.companyManagerIds;
      const currentUserSocialId = store(globalModuleNamespace).getters['/socialId'];
      const currentCommercialRegistrationNumber = store(globalModuleNamespace).getters['/commercialRegistrationNumber'];
      const currentUserFullName = store(globalModuleNamespace).getters['/fullName'];
      const isCurrentUserOrganization = store(globalModuleNamespace).getters['/isOrganization'];
      const impersonatedBySocialId = store(globalModuleNamespace).getters['/impersonatedBySocialId'];
      const impersonatedByCaseParty = store().state.lawsuitRequest.caseParties.find(cp => +cp.socialId === +impersonatedBySocialId);
      const isProsecutorsContainsPerson = store()
        .state.lawsuitRequest.caseParties.filter(cp => isProsecutorOrProsecutorRepresentative(cp))
        .some(cp => isPersonOrOrganizationOwner(cp) || !!cp.socialId);
      const userInfo = store(globalModuleNamespace).state.userInfo;
      const casePartyWithInvalidNationality = store().state.lawsuitRequest.caseParties.find(cp => cp.nationalityCountryId == 0);
      const personWithInvalidSocialIdType = store().state.lawsuitRequest.caseParties.find(cp => isPerson(cp) && cp.socialIdType == 0);
      const casePartyWithUnverifiedAttorney = store().state.lawsuitRequest.caseParties
        .flatMap(p =>
          (p.relatedPartiesInfo || [])
            .filter(r =>
              [casePartyRoleEnum.agent, casePartyRoleEnum.lawyer, casePartyRoleEnum.representative].includes(r.casePartyRole) &&
              !r.isVerified &&
              r.attorneyNumber
            )
            .map(r => ({
              fullName: [p.firstName, p.fatherName, p.grandFatherName, p.familyName].filter(Boolean).join(' '),
              attorneyNumber: r.attorneyNumber,
            }))
        )[0];
      if (casePartyWithUnverifiedAttorney) {
        reject(ar.personInformation.attorneyVerificationError({
          fullName: casePartyWithUnverifiedAttorney.fullName,
          attorneyNumber: casePartyWithUnverifiedAttorney.attorneyNumber,
        }));
      }

      if (isNoOneExists(prosecutorsWithoutInheritorsLength)) { reject(ar.lawsuitValidations.shouldAddProsecutor + (oneOrMoreExists(store().getters.prosecutorsLength) ? ` ${ar.lawsuitValidations.moreOne}` : '')); }
      if (!store().getters.isViewMode && selectedCaseType && selectedCaseType.mustHaveNoDefendant && !isNoOneExists(store().getters.defendantsLength)) {
        reject(ar.lawsuitValidations.preventAddingDefendantTerminationLawsuit);
      }
      if (
        selectedCaseType && !selectedCaseType.mustHaveNoDefendant &&
        isNoOneExists(defendantsWithoutInheritorsLength) &&
        requiredDefendantInCaseCategory(
          store(lookupsNamespace).state.caseTypesByCategory[store().state.lawsuitRequest.case.caseCategoryId],
          store().state.lawsuitRequest.case.caseTypeId
        )
      ) {

        reject(ar.lawsuitValidations.shouldAddDefendant + (oneOrMoreExists(store().getters.defendantsLength) ? ` ${ar.lawsuitValidations.moreOne}` : ''));
      }
      const preventedCasesFromAddingRepresentative = [caseClassificationEnum.proofs, caseClassificationEnum.criminal];
      if (preventedCasesFromAddingRepresentative.indexOf(store().state.lawsuitRequest.case.caseClassificationIdNew) === -1) {
        const prosecutorsList = store().state.lawsuitRequest.caseParties.filter(x => isProsecutor(x) && isPersonNotInheritor(x) && !x.isRequestApplicant);
        for (let index = 0; index < prosecutorsList.length; index++) {
          const element = prosecutorsList[index];
          const representative = store().state.lawsuitRequest.caseParties.filter(x => x.relatedPartiesInfo.filter(e => e.socialId == element.socialId).length > 0);
          if ((element.socialIdType != socialIdentityTypeEnum.nationalId &&
            element.socialIdType != socialIdentityTypeEnum.regularResidency &&
            element.socialIdType != socialIdentityTypeEnum.unifiedNumber
          ) && (representative.length == 0 ||
            (representative.length > 0 && (representative || []).every
              (x => x.socialId != userInfo.socialId && (x.socialIdType != socialIdentityTypeEnum.nationalId &&
                x.socialIdType != socialIdentityTypeEnum.regularResidency &&
                x.socialIdType != socialIdentityTypeEnum.unifiedNumber)))
            ) && element.socialId != userInfo.socialId) {
            reject(ar.lawsuitValidations.applicantMustBeRepresentative);
            reject(element.socialId);
          }
          const age = calculateAge(element.dateOfBirth);
          if (age < 18) {
            if (representative.length == 0 && element.socialId != userInfo.socialId) {
              reject(ar.lawsuitValidations.preventSaveWithoutRepresentative);
            }
          }
        }
      }
      const caseParties = {
        ...prosecutors,
        ...defendants,
      };
      Object.values(caseParties)
        .forEach((party) => {
          if (party.partyType === partyTypeEnum.judicialGuard || party.partyType === partyTypeEnum.liquidator) {
            const representatives = party.representatives || {};
            const hasValidRepresentative = Object.values(representatives)
              .some(rep => (party.partyType === partyTypeEnum.judicialGuard && rep.casePartyRole === casePartyRoleEnum.judicialGuard) || (party.partyType === partyTypeEnum.liquidator && rep.casePartyRole === casePartyRoleEnum.liquidator));
            if (!hasValidRepresentative && party.partyType === partyTypeEnum.liquidator) {
              reject(ar.lawsuitValidations.shouldAddLiquidatorRepresentative);
            }
            if (!hasValidRepresentative && party.partyType === partyTypeEnum.judicialGuard) {
              reject(ar.lawsuitValidations.shouldAddJudicialGuardRepresentative);
            }
          }
        });

      const defendantCessationWithoutObserver = Object.values(defendants)
        .find(party =>
          Number(party.partyType) === partyTypeEnum.cessation &&
          !Object.values(party.representatives || {})
            .some(rep => Number(rep.casePartyRole) === casePartyRoleEnum.cessationObserver)
        );
      if (defendantCessationWithoutObserver) {
        reject(ar.lawsuitValidations.shouldAddCessationObserverRepresentative);
      }

      if (!isProsecutorsContainsPerson) {
        for (const key in prosecutors) {
          if (Object.prototype.hasOwnProperty.call(prosecutors, key)) {
            const prosecutor = prosecutors[key];
            if (
              !isPerson(prosecutor) &&
              !isOrganization(prosecutor) &&
              !isCasePartyNotNeedRepresentative(prosecutor) &&
              prosecutor.socialId !== currentUserSocialId &&
              !Object.keys(prosecutor.representatives).length
            ) {
              reject(
                ar.lawsuitValidations.shouldAddRepresentative(
                  getCasePartyName(prosecutor, [...store(lookupsNamespace).state.governmentAgencies, ...store(lookupsNamespace).state.associations])
                )
              );
            }
          }
        }
      }

      if (userInfo.userType === userType.najizCitizen &&
        store().state.lawsuitRequest.caseParties.some(cp => isLawyer(cp) && +getCasePartyId(cp).id === +currentUserSocialId))
        reject(ar.lawsuitValidations.canntAddyouAsLawyer);

      if (userInfo.userType === userType.najizLawyer &&
        !store().state.lawsuitRequest.caseParties.some(cp => isLawyer(cp) && +getCasePartyId(cp).id === +currentUserSocialId))
        reject(ar.lawsuitValidations.lawyerShouldBeAdded);

      if (!prosecutorAndRepresentativeIds.some(cpi => +cpi.id === +currentUserSocialId || +cpi.id === +currentCommercialRegistrationNumber) && !companyManagerIds.some(cpi => +cpi.id === +currentUserSocialId)) {
        reject(ar.lawsuitValidations.currentUserShouldExists(currentUserFullName));
      }
      if (!store().getters.isViewMode && currentUserSocialId.startsWith('1')) {
        for (const key in defendants) {
          if (Object.prototype.hasOwnProperty.call(defendants, key) && isPerson(defendants[key])
            && (defendants[key].socialIdType == socialIdentityTypeEnum.nationalId || defendants[key].socialIdType == socialIdentityTypeEnum.regularResidency)
            && !defendants[key].isRetrievedFromMoi) {
            reject(ar.lawsuitValidations.defendantShouldBeRetrievedFromMoi(getCasePartyName(defendants[key])));
          }
        }
      }
      if (isCurrentUserOrganization && (+(impersonatedByCaseParty || {}).unifiedNumber !== +currentUserSocialId || +(impersonatedByCaseParty || {}).commercialRegistrationNumber !== +currentCommercialRegistrationNumber)
        && !((impersonatedByCaseParty || {}).relatedPartiesInfo || []).some(rpi => +rpi.unifiedNumber === +currentUserSocialId || +rpi.commercialRegistrationNumber === +currentCommercialRegistrationNumber))
        reject(ar.lawsuitValidations.currentRepresentativeShouldExists(getCasePartyName(impersonatedByCaseParty), currentUserFullName));

      if (casePartyWithInvalidNationality)
        reject(ar.lawsuitValidations.casePartyInvalidNationality(getCasePartyName(casePartyWithInvalidNationality)));

      if (personWithInvalidSocialIdType)
        reject(ar.lawsuitValidations.casePartyInvalidSocialIdType(getCasePartyName(personWithInvalidSocialIdType)));

      resolve();
    }),
  validateCaseSubmission: bypassValidation =>
    new Promise((resolve, reject) => {
      if (bypassValidation) resolve();
      const requiredAttachmentsTypes = store().state.lawsuitRequest.attachmentTypes.filter(a => a.isRequired);
      const attachments = Object.values(store().state.attachments.data);
      const missingRequiredAttachments = requiredAttachmentsTypes.filter(r => attachments.every(a => r.id != a.category));
      if (missingRequiredAttachments && missingRequiredAttachments.length > 0) {
        const missingRequiredAttachmentsNames = missingRequiredAttachments.map(a => a.name).join(', ');
        const validationMessage = `${ar.lawsuitValidations.missingAttachmentType} ${missingRequiredAttachmentsNames}`;
        reject(validationMessage);
      }

      resolve();
    }),
  validateDraftLawsuit: () =>
    new Promise((resolve, reject) => {
      const prosecutorIds = store().getters.prosecutorIds;
      const prosecutorRepresentativeIds = store().getters.prosecutorRepresentativeIds;
      const prosecutorAndRepresentativeIds = prosecutorIds.concat(prosecutorRepresentativeIds);
      const companyManagerIds = store().getters.companyManagerIds;
      const currentUserSocialId = store(globalModuleNamespace).getters['/socialId'];
      const currentCommercialRegistrationNumber = store(globalModuleNamespace).getters['/commercialRegistrationNumber'];
      const currentUserFullName = store(globalModuleNamespace).getters['/fullName'];
      const isCurrentUserOrganization = store(globalModuleNamespace).getters['/isOrganization'];
      const impersonatedBySocialId = store(globalModuleNamespace).getters['/impersonatedBySocialId'];
      const impersonatedByCaseParty = store().state.lawsuitRequest.caseParties.find(cp => +cp.socialId === +impersonatedBySocialId);
      const casePartyWithInvalidNationality = store().state.lawsuitRequest.caseParties.find(cp => cp.nationalityCountryId == 0);
      const personWithInvalidSocialIdType = store().state.lawsuitRequest.caseParties.find(cp => isPerson(cp) && cp.socialIdType == 0);
      const userInfo = store(globalModuleNamespace).state.userInfo;

      if (userInfo.userType === userType.najizCitizen &&
        store().state.lawsuitRequest.caseParties.some(cp => isLawyer(cp) && +getCasePartyId(cp).id === +currentUserSocialId))
        reject(ar.lawsuitValidations.canntAddyouAsLawyer);

      if (userInfo.userType === userType.najizLawyer &&
        !store().state.lawsuitRequest.caseParties.some(cp => isLawyer(cp) && +getCasePartyId(cp).id === +currentUserSocialId))
        reject(ar.lawsuitValidations.lawyerShouldBeAdded);

      if (!prosecutorAndRepresentativeIds.some(cpi => +cpi.id === +currentUserSocialId || +cpi.id === +currentCommercialRegistrationNumber) && !companyManagerIds.some(cpi => +cpi.id === +currentUserSocialId)) {
        reject(ar.lawsuitValidations.currentUserShouldExists(currentUserFullName));
      }

      if (isCurrentUserOrganization && (+(impersonatedByCaseParty || {}).unifiedNumber !== +currentUserSocialId || +(impersonatedByCaseParty || {}).commercialRegistrationNumber !== +currentCommercialRegistrationNumber)
        && !((impersonatedByCaseParty || {}).relatedPartiesInfo || []).some(rpi => +rpi.unifiedNumber === +currentUserSocialId || +rpi.commercialRegistrationNumber === +currentCommercialRegistrationNumber))
        reject(ar.lawsuitValidations.currentRepresentativeShouldExists(getCasePartyName(impersonatedByCaseParty), currentUserFullName));

      if (casePartyWithInvalidNationality)
        reject(ar.lawsuitValidations.casePartyInvalidNationality(getCasePartyName(casePartyWithInvalidNationality)));

      if (personWithInvalidSocialIdType)
        reject(ar.lawsuitValidations.casePartyInvalidNationality(getCasePartyName(personWithInvalidSocialIdType)));

      resolve();
    }),
  isLaborRequestAllowed: (laborRequestTypeId, mustBeAlone, maxOccurrence) =>
    new Promise((resolve, reject) => {
      mustBeAlone = mustBeAlone === 'true';
      maxOccurrence = !isNaN(+maxOccurrence) ? +maxOccurrence : 0;
      const laborRequestOccurrences = store().getters.laborRequestOccurrences;
      const singleLaborRequestName = store().getters.singleLaborRequestName;
      const currentRequestOccurrences = laborRequestOccurrences[laborRequestTypeId] || 0;
      const requestsNumber = Object.keys(laborRequestOccurrences).length;

      if (singleLaborRequestName) {
        reject(
          ar.lawsuitDetails.laborRequest.requests.gridContainsSingleRequest(
            singleLaborRequestName.laborRequestTypeName
          )
        );
      }
      if (mustBeAlone && requestsNumber > 1) { reject(ar.lawsuitDetails.laborRequest.requests.mustBeAloneError); }
      if (!!maxOccurrence && currentRequestOccurrences >= maxOccurrence) { reject(ar.lawsuitDetails.laborRequest.requests.maxOccurrenceError(maxOccurrence)); }

      resolve();
    }),
  isLaborEvidenceAllowed: laborEvidenceTypeId =>
    new Promise((resolve, reject) => {
      const evidences = store().state.lawsuitRequest.case.evidences;

      if (evidences.some(e => e.evidenceType === laborEvidenceTypeId)) { reject(ar.lawsuitDetails.laborRequest.evidences.duplicationError); }

      resolve();
    }),
  validateCaseParties: () =>
    new Promise((resolve) => {
      resolve();
    }),
  validateCaseParty: () =>
    new Promise((resolve) => {
      resolve();
    }),
  validateCasePartyRepresentative: () =>
    new Promise((resolve) => {
      resolve();
    }),
  validateRemovingCaseParty: caseParty =>
    new Promise((resolve) => {
      resolve();
    }),
  validateRemovingCasePartyRepresentative: casePartyRepresentative =>
    new Promise((resolve) => {
      resolve();
    }),
  isIdAllowed: () =>
    new Promise(async (resolve, reject) => {
      const caseParty = store().getters.selectedCaseParty;
      const casePartyId = store().getters.selectedCasePartyId;
      const prosecutorIds = store().getters.prosecutorIds;
      const defendantIds = store().getters.defendantIds;
      const prosecutorRepresentativeIds = store().getters.prosecutorRepresentativeIds;
      const defendantRepresentativeIds = store().getters.defendantRepresentativeIds;
      const companyManagers = store().getters.companyManagers;
      const prosecutorCompanyManagersIds = companyManagers.filter(isProsecutor).map(getCasePartyId);
      const defendantCompanyManagersIds = companyManagers.filter(isDefendant).map(getCasePartyId);
      const prosecutorAndRepresentativeIds = prosecutorIds.concat(prosecutorRepresentativeIds).concat(prosecutorCompanyManagersIds);
      const defendantAndRepresentativeIds = defendantIds.concat(defendantRepresentativeIds).concat(defendantCompanyManagersIds);
      const casePartyRelatedPartyId = store().getters.selectedCasePartyRelatedPartyId;
      const casePartyRepresentativeIds = store().getters.selectedCasePartyRepresentativeIds;
      const currentUserSocialId = store(globalModuleNamespace).getters['/socialId'];
      const currentCommercialRegistrationNumber = store(globalModuleNamespace).getters['/commercialRegistrationNumber'];
      const isCurrentUserOrganization = store(globalModuleNamespace).getters['/isOrganization'];
      const impersonatedBySocialId = store(globalModuleNamespace).getters['/impersonatedBySocialId'];
      const userInfo = store(globalModuleNamespace).state.userInfo;

      if (userInfo.userType === userType.najizCitizen && isLawyer(caseParty) && +casePartyId.id === +currentUserSocialId) {
        reject(ar.lawsuitValidations.lawyerShouldNotBeAdded);
      }

      if (store().getters.isAddSubMode) {
        if (isProsecutor(caseParty) && isCasePartyExists(casePartyId, prosecutorIds)) {
          reject(ar.lawsuitValidations.isProsecutorCasePartyExists);
        }

        if (isDefendant(caseParty) && isCasePartyExists(casePartyId, defendantIds)) {
          reject(ar.lawsuitValidations.isDefendantCasePartyExists);
        }

        if (
          isRepresentative(caseParty) &&
          isCasePartyExists(casePartyId, casePartyRepresentativeIds)
        ) { reject(ar.lawsuitValidations.isCasePartyRepresentativeExists); }
      } else if (store().getters.isEditSubMode) {
        if (
          isProsecutor(caseParty) &&
          isCasePartyExistsExceptSelected(casePartyId, prosecutorIds)
        ) {
          reject(ar.lawsuitValidations.isProsecutorCasePartyExistsForTheSame);
        }

        if (isDefendant(caseParty) && isCasePartyExistsExceptSelected(casePartyId, defendantIds)) {
          reject(ar.lawsuitValidations.isDefendantCasePartyExists);
        }

        if (
          isRepresentative(caseParty) &&
          isCasePartyExistsExceptSelected(casePartyId, casePartyRepresentativeIds)
        ) { reject(ar.lawsuitValidations.isCasePartyRepresentativeExists); }
      }

      if (
        (isProsecutor(caseParty) ||
          isProsecutorRepresentative(caseParty) ||
          isProsecutorRepresentativeRepresentative(caseParty)) &&
        isCasePartyExists(casePartyId, defendantAndRepresentativeIds)
      ) { reject(ar.lawsuitValidations.isCasePartyExistsAsDefendantOrRepresentative); }

      if (
        (isDefendant(caseParty) ||
          isDefendantRepresentative(caseParty) ||
          isDefendantRepresentativeRepresentative(caseParty)) &&
        isCasePartyExists(casePartyId, prosecutorAndRepresentativeIds)
      ) { reject(ar.lawsuitValidations.isCasePartyExistsAsProsecutorOrRepresentative); }

      if ((+casePartyId.id === +currentUserSocialId || +caseParty.socialId === +currentUserSocialId || +casePartyId.id === +currentCommercialRegistrationNumber || +casePartyId.id === +impersonatedBySocialId)
        && (isDefendant(caseParty) || isDefendantRepresentative(caseParty) || isDefendantRepresentativeRepresentative(caseParty))
      ) { reject(ar.lawsuitValidations.cannotAddCurrentUserAsDefendant); }

      if (+casePartyId.id === +currentUserSocialId && isInheritor(caseParty)
      ) { reject(ar.lawsuitValidations.cannotAddCurrentUserAsInheritor); }

      if ((+casePartyId.id === +currentUserSocialId || +casePartyId.id === +currentCommercialRegistrationNumber)
        && isOrganizationOwner(caseParty) && isCurrentUserOrganization)
        reject(ar.lawsuitValidations.cannotAddCurrentUserAsOrganizationFromNajizOrg);

      if (isRepresentative(caseParty) && isSameCaseParties(casePartyId, casePartyRelatedPartyId)) { reject(ar.lawsuitValidations.isCasePartyExists); }
      if (caseParty.isRetrievedFromMoi && isDead(caseParty) && isPersonNotInheritor(caseParty))
        reject(ar.lawsuitValidations.cantAddDeadPersons);
      if (caseParty.isRetrievedFromMoi && !isDead(caseParty) && !isPersonNotInheritor(caseParty) && !caseParty.relatedDeceasedSocialId)
        reject(ar.lawsuitValidations.cantAddAlivePersons);
      resolve();
    }),

};
